import React, { useState, useEffect, memo } from 'react';
import CommonDatePicker from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import * as moment from 'moment';
import get from 'lodash/get';
import _ from 'lodash';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
import {
  LegalUpload,
  LegalUploaded,
  UploadFileToS3,
  finalSanctionUpdateAPI,
  finalSanctionGETAPI
} from '../../../common/constants/api';
const file_icon = '/images/icons/CmDashIcons/file_icon.svg';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import PopUp from '../../../common/components/PopUp/PopUp';
import { legal_container, viewlegalBox } from './FinalSaction.module.css';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';

const validationSchema = Yup.object().shape({
  agencyName: Yup.string().required('Required'),
  personName: Yup.string().required('Required'),

  mobile: Yup.number('numbers only')
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .min(10, 'must be a 10 digit no')
    .required('A phone number is required'),
  email: Yup.string()
    .required('Required')
    .max(50, 'Email address is Too Long!')
    .matches(
      /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
      'Please Enter Valid Email Id'
    ),

  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  file: Yup.array().when('isEditMode', {
    is: false,
    then: Yup.array()
      .min(1, 'must upload 1 files atleast')
      .required('file is required')
      .of(Yup.string().required())
  }),

  imgUrl: Yup.string().when('isEditMode', {
    is: false, // alternatively: (val) => val == true
    then: Yup.string().required(' required')
  })
});

const Legal = () => {
  const [legalView, setLegalView] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const [legalDocId, setLegalDocId] = useState('');
  const [getresponse, setResponse] = useState(false);
  const [getResponseCompleted, setgetResponseCompleted] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [fullImage, setFullImage] = useState(false);

  return (
    <Formik
      initialValues={{
        isEditMode: false,
        agencyName: '',
        personName: '',
        mobile: '',
        email: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(moment().format('YYYY')),
          label: String(moment().format('YYYY'))
        },
        file: [],
        imgUrl: []
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting,
        setValues
      }) => {
        let fullData = `${values?.date?.value} ${values?.month?.label} ${values?.year?.value}`;
        let LegalValueList = [
          { name: 'Name of the Agency', value: values?.agencyName },
          { name: 'Person Name', value: values?.personName },
          { name: 'Contact No.', value: values?.mobile },
          { name: 'Email Id', value: values?.email },
          { name: 'Date Submitted', value: fullData }
        ];

        ////update api
        const LegalupdateFun = () => {
          let body = {
            agencyName: values?.agencyName,
            personName: values?.personName,
            contactNumber: values?.mobile,
            emailId: values?.email,

            submittedDate:
              values?.year?.value +
              '-' +
              (parseInt(values?.month?.value, 10) < 10
                ? '0' + parseInt(values?.month?.value, 10)
                : values?.month?.value) +
              '-' +
              (parseInt(values?.date?.value, 10) < 10
                ? '0' + parseInt(values?.date?.value, 10)
                : values?.date?.value),
            legalReportDocId: legalDocId
          };
          setType('loading');
          setText('Please Wait while submitting data...');
          setShow(true);
          setDontClose(true);
          finalSanctionUpdateAPI(getApplicantionInfo().leadId, 'legal', body)
            .then(res => {
              setShow(false);
              setResponse(true);
              setLegalView(false);
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
            });
        };

        //get all data
        useEffect(() => {
          setType('loading');
          setText('Please wait while retrieving data...');
          setShow(true);
          setDontClose(true);
          finalSanctionGETAPI(getApplicantionInfo().leadId, 'legal')
            .then(res => {
              if (res.legalDetails && res.legalReport) {
                setResponse(true);
              }

              let formatDate = res?.legalDetails?.submittedDate;
              setImgLinkData(res?.legalReport?.url);
              setLegalDocId(res?.legalDetails?.legalReportDocId);
              setValues({
                ...values,
                agencyName: res?.legalDetails?.agencyName,
                personName: res?.legalDetails?.personName,
                mobile: res?.legalDetails?.contactNumber,
                email: res?.legalDetails?.emailId,
                isEditMode: res?.legalReport?.url ? true : false,
                date: {
                  value: formatDate ? moment(formatDate).format('DD') : '',
                  label: formatDate ? moment(formatDate).format('DD') : 'Date'
                },
                month: {
                  value: formatDate ? moment(formatDate).format('MM') : '',
                  label: formatDate
                    ? moment(formatDate).format('MMMM')
                    : 'Month'
                },
                year: {
                  value: moment(formatDate).format('YYYY'),
                  label: moment(formatDate).format('YYYY')
                }
              });
              setgetResponseCompleted(true);
              setShow(false);
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
              setgetResponseCompleted(true);
            });
        }, []);

        //upload
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);

          await LegalUpload(getApplicantionInfo().leadId)
            .then(res => {
              setLegalDocId(res?.requestId);
              UploadFileToS3(res.url, values.file[0][0]).then(() => {
                LegalUploaded(
                  getApplicantionInfo().leadId,
                  res?.requestId || ''
                ).then(res => {
                  setType('success');
                  setText('Uploaded the File successfully.');
                  setShow(true);
                  setDontClose(false);
                });
              });
            })
            .catch(err => {
              setShow(false);
            });
        }
        useEffect(() => {
          if (values.file[0] && values.file[0][0]) {
            fileUpload();
          }
        }, [values.file[0]]);
        return (
          <React.Fragment>
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 sm:px-5 "
            >
              <div className="font-medium mb-3 text-base">Legal Details</div>

              {(!getresponse || legalView) && getResponseCompleted && (
                <div>
                  <div className={`${legal_container}`}>
                    <CommonInput
                      name="agencyName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.agencyName}
                      stylesContainer={{
                        maxWidth: '100%',
                        marginBottom: '40px'
                      }}
                      legendName="Name of the Agency"
                      error={touched.agencyName && errors.agencyName}
                      errorMsg={errors.agencyName}
                      touched={touched.agencyName}
                    />
                    <CommonInput
                      name="personName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.personName}
                      stylesContainer={{
                        maxWidth: '100%',
                        marginBottom: '40px'
                      }}
                      legendName="Person Name"
                      error={touched.personName && errors.personName}
                      errorMsg={errors.personName}
                      touched={touched.personName}
                    />
                    <div>
                      <div
                        style={{ marginTop: '17px' }}
                        className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                      >
                        +91
                      </div>

                      <CommonInput
                        name="mobile"
                        maxLength={10}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.mobile}
                        stylesContainer={{
                          marginBottom: '40px',
                          maxWidth: '100%'
                        }}
                        inputStyle={{
                          paddingLeft: '45px',
                          letterSpacing: '1px'
                        }}
                        onBlurStyle={{
                          paddingLeft: '20px'
                        }}
                        legendStyle={{
                          paddingLeft: errors.mobile ? '20px' : '20px'
                        }}
                        legendName="Contact Number"
                        error={touched.mobile && errors.mobile}
                        className={`pt-24`}
                        touched={touched.mobile}
                        errorMsg={errors.mobile}
                      />
                    </div>

                    <CommonInput
                      name="email"
                      id="email"
                      onChange={handleChange}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                      value={values.email}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      legendName="Email Id"
                      error={touched.email && errors.email}
                      errorMsg={errors.email}
                      touched={touched.email}
                    />

                    <div className="mt-3">
                      <p>Date Submitted</p>
                      <CommonDatePicker
                        datePickerContainerstyle={{
                          height: '52px'
                        }}
                        dropdownStyle={{
                          marginTop: '10px'
                        }}
                        onChangeMonth={(value, isValidDate) => {
                          setFieldValue('month', value, true);
                          setFieldTouched('month', true, false);
                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeYear={(value, isValidDate) => {
                          setFieldValue('year', value, true);
                          setFieldTouched('year', true, false);

                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeDate={value => {
                          setFieldValue('date', value, true);
                          setFieldTouched('date', true, false);
                        }}
                        valueMonth={values.month}
                        valueYear={values.year}
                        valueDate={values.date}
                        errorYear={
                          touched.year && get(errors, 'year.value', false)
                        }
                        touchedYear={touched.year}
                        onBlurYear={() => {
                          setFieldTouched('year', true, true);
                        }}
                        errorMonth={
                          touched.month && get(errors, 'month.value', false)
                        }
                        touchedMonth={touched.month}
                        onBlurMonth={() => {
                          setFieldTouched('month', true, true);
                        }}
                        // errors.date.value
                        errorDate={
                          touched.date && get(errors, 'date.value', false)
                        }
                        touchedDate={touched.date}
                        onBlurDate={() => {
                          setFieldTouched('date', true, true);
                        }}
                        errorMsg=""
                      />
                    </div>
                  </div>
                  <div className="mt-10">
                    <p className="font-medium mb-3 text-base">
                      Upload Legal Report
                    </p>
                    <div
                      className="bg-white  flex justify-center rounded-lg border border-navy-200 md:border-none
                        py-9  pr-5 pl-8  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
                    >
                      {imgLinkData && !Edit1 ? (
                        <div className="md:mr-auto md:ml-3 ">
                          <ShowGetImage img={imgLinkData} setEdit={setEdit1} />
                        </div>
                      ) : (
                        <GlobalUploadComp
                          data={values}
                          imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          initialImg={initialImg}
                          subInst="Click here or drop here to upload"
                          subtext="CHOOSE IMAGE"
                        />
                      )}
                    </div>
                  </div>
                  <button
                    type="submit"
                    onClick={() => {
                      LegalupdateFun();
                    }}
                    disabled={
                      !_.isEmpty(errors) ||
                      values.date.value == '' ||
                      values.month.value == '' ||
                      values.year.value == '' ||
                      values.mobile == '' ||
                      values.email == '' ||
                      values.personName == '' ||
                      values.agencyName == ''
                    }
                    className={
                      ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
                    }
                  >
                    Submit
                  </button>
                </div>
              )}
              {getresponse && !legalView && getResponseCompleted && (
                <div className="bg-orange-200 pl-1  mr-4 md:mr-0 md:w-11/12 rounded relative xl:w-8/12">
                  <div className="bg-navy-700 px-4 py-6  rounded-r">
                    <div
                      className={`font-roboto text-black-500 text-sm ${viewlegalBox}`}
                    >
                      {LegalValueList &&
                        LegalValueList.map((each, index) => {
                          return (
                            <div key={index} className="flex md:block">
                              <div className="w-1/2 md:w-auto font-nomal text-sm text-grey-1003">
                                {each?.name}
                              </div>
                              <div className="font-bold w-1/2 md:w-auto">
                                <span className="md:hidden mx-1">:</span>
                                {each?.value}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    <div
                      className="bg-green-dim rounded p-2 w-32 text-green-1350 mt-3  cursor-pointer"
                      onClick={() => setFullImage(true)}
                    >
                      <img src={file_icon} alt="" />
                      <span className="pl-1"> Legal Report</span>
                    </div>
                  </div>
                </div>
              )}
            </Form>
            <ShowDoc
              file={imgLinkData}
              show={fullImage}
              setShow={setFullImage}
              autoCheck={true}
            />

            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={dontClose}
              autoClose={type === 'success'}
            />
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default memo(withErrorHandler(Legal));
